<div>
  <label class="block">
    <app-label
      [text]="label"
      [reverse]="reverse"
      [required]="required"
    >
    </app-label>
    <input
      [type]="type"
      [formControl]="control"
      class="text-black px-12 h-48 rounded-lg block w-full"
    />
    <app-required-message [text]="requiredErrorMessage"></app-required-message>
  </label>
</div>
